import api from './axiosInstance';

export const workerApi = {
  list: (params = {}) => api.get('/workers', {params}),
  search: (params = {}) => api.get('/workers/search', {params}),
  getById: id => api.get(`/workers/${id}`),
  create: data => api.post('/workers', data),
  update: (id, data) => api.put(`/workers/${id}`, data),
  delete: id => api.delete(`/workers/${id}`),
  reactivate: id => api.put(`/workers/${id}/reactivate`),
  getAssignments: id => api.get(`/workers/${id}/assignments`),
  getTaskAssignments: (params = {}) => api.get('/workers/task-assignments', {params}),
  uploadAvatar: (id, image) => {
    const formData = new FormData();
    formData.append('avatar', {
      uri: image.uri,
      type: image.type || 'image/jpeg',
      name: image.fileName || 'avatar.jpg',
    });
    return api.post(`/workers/${id}/avatar`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    });
  },
  // Org unit assignment
  assignOrgUnit: (workerId, orgUnitId) =>
    api.post(`/workers/${workerId}/org-units`, {orgUnitId}),
  removeOrgUnit: (workerId, orgUnitId) =>
    api.delete(`/workers/${workerId}/org-units/${orgUnitId}`),
  getOrgUnits: workerId => api.get(`/workers/${workerId}/org-units`),
  // User linking
  linkUser: (workerId, userId) =>
    api.post(`/workers/${workerId}/link-user`, {userId}),
  unlinkUser: workerId => api.delete(`/workers/${workerId}/link-user`),
};
